import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EnvironmentConfiguration, TenantInfoRequest } from '@jms/model';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;
import { UtilService } from '@jms/utils/util.services';
import { Observable } from 'rxjs';
import { ApplicationActions } from '@jms/tenant/module.jms.state';
import { ContextService } from '@jms/ui/ui.standalone.services/context.service';
// logged-in.guard.ts

@Injectable()
export class AuthGuard {
  private token: string;
  private tenantInfo: TenantInfoRequest;
  private environment: EnvironmentConfiguration;

  constructor(
    private router: Router,
    private location: Location,
    private context: ContextService,
    private actions: ApplicationActions,
    private jwt: JwtHelperService
  ) {
    actions.token$.subscribe(x => (this.token = x));
    actions.tenantInfo$.subscribe(x => (this.tenantInfo = x));
    this.environment = ConfigService.environment;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const url = this.location.path();

    if (!url.toLowerCase().startsWith('/callback')) {
      const token = UtilService.getURLParameter('token', url);
      if (token) {
        let stateUrl = state.url;
        const index = stateUrl.indexOf('?');
        if (index >= 0) {
          stateUrl = stateUrl.substring(0, index);
        }
        const queryParams = {
          queryParams: {
            token: token,
            returnUrl: stateUrl
          }
        };
        this.router.navigate([`/callback`], queryParams);
        return false;
      }
    }

    if (this.token && !this.jwt.isTokenExpired(this.token)) {
      if (!this.tenantInfo) {
        this.actions.getTenantInfo(state.url, true);
        return false;
      }

      return true;
    }

    const callback = `${this.context.origin}${state.url}`;
    localStorage.removeItem('auth_token');
    // Redirect the user before denying them access to this route
    UtilService.navigate(this.environment.jms.logoutHref, callback);
    return false;
  }
}
